
export const fieldsConfig = [
  {
    name: "trade_name",
    label: "Trade of Work",
    type: "text",
    required: true,
  },

  // {
  //   name: "is_activated",
  //   label: "Status",
  //   type: "boolean",          // 🔥 NEW TYPE
  //   // required: true,
  //   uiType: "toggle",         // "checkbox" | "toggle"
  //   defaultValue: true   ,     // optional
  //    wrapperClassName: "flex gap-2  justify-start items-center" 
  // },
];